import { render, staticRenderFns } from "./HiddenScoreReportMessage.vue?vue&type=template&id=38d3f125&scoped=true&"
import script from "./HiddenScoreReportMessage.vue?vue&type=script&lang=js&"
export * from "./HiddenScoreReportMessage.vue?vue&type=script&lang=js&"
import style0 from "./HiddenScoreReportMessage.vue?vue&type=style&index=0&id=38d3f125&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d3f125",
  null
  
)

export default component.exports